import { Box, Chip } from "@mui/material";
import { useTranslation } from "react-i18next";

import { notificationCategoriesList, NotificationCategoryEnum } from "../../enums/notifications";

const NotificationsTabs = ({
  activeTab,
  setActiveTab,
}: {
  activeTab: NotificationCategoryEnum;
  setActiveTab: (tab: NotificationCategoryEnum) => void;
}) => {
  const { t } = useTranslation();

  return (
    <Box sx={styles.container}>
      {notificationCategoriesList.map((tab) => (
        <Chip
          key={tab}
          label={t(`layout.notifications.${tab}`)}
          component="button"
          variant="outlined"
          onClick={() => setActiveTab(tab)}
          sx={styles.chip(activeTab === tab)}
        />
      ))}
    </Box>
  );
};

export default NotificationsTabs;

const styles = {
  container: {
    display: "flex",
    gap: "8px",
    px: "24px",
  },
  chip: (isActive: boolean) => ({
    border: "none",
    padding: "1px 4px",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: isActive ? 600 : 400,
    lineHeight: "24px",
    color: isActive ? "var(--Green---100, #008B07)" : "var(--Dark---600, #707070)",
    background: isActive ? "var(--Green---25, #C2E6C4)" : "transparent",
  }),
};
